export enum ProactiveDraftsLoadingState {
    NotLoaded,
    Loading,
    Completed,
    Failed,
}
